const WhyUs = ({companyDetail}) => {
  const whyValorellePoints = [
    {
      title: companyDetail.why_us_subhead_1,
      description:
        companyDetail.why_us_1
    },
    {
      title: companyDetail.why_us_subhead_2,
      description:
        companyDetail.why_us_2
    },
    {
      title: companyDetail.why_us_subhead_3,
      description:
        companyDetail.why_us_3
    },
    // {
    //   title: "Affordable and Premium Perfumes Under ₹1000",
    //   description:
    //     "Smell like luxury, spend like smart. Our curated collection offers affordable perfumes with rich notes and elegant packaging that punch well above their price."
    // },
    // {
    //   title: "Fragrances for Every Mood — Not Every Label",
    //   description:
    //     "Whether you're feeling romantic, powerful, or fresh for summer, Valorelle lets you pick perfumes based on your mood, not outdated gender norms. We're for you, not for “him” or “her.”"
    // }
  ];

  return (
    <>
      <style>
        {`.elegant-box {
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 16px;
  transition: all 0.3s ease;  
  border-color: #c2a57c; /* subtle gold tone */
  box-shadow: 0 6px 20px rgba(194, 165, 124, 0.2); /* warm gold shadow */
  
  border-left: 4px solid #c2a57c;
  padding-left: 1.5rem;
}

.elegant-box:hover {
  transform: translateY(-5px);
}

.elegant-box:hover {
}
`}
      </style>
      <section className="section-lg-space">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="about-us-title text-center mb-5">
              <h3 className='inter-font text-white'>Why Valorelle?</h3>
                <h2 className="center text-white">{companyDetail.why_us_heading}</h2>
              </div>

              <div className="slider-3_1 product-wrapper row">
                {whyValorellePoints.map((point, index) => (
                  <div className="col-sm-4 mt-2" key={index}>
                    <div className="clint-contain elegant-box h-100 p-4 rounded-4 ">
                      <h4 className="fw-bold text-theme inter-font">{point.title}</h4>
                      <p>{point.description}</p>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );

}

export default WhyUs;